import axios from "axios";
import { convertToCamelCase } from "../../redux/actions/helpers";
import Cookies from "js-cookie";
import { dataFormatter } from "../admin";

export const loadUsers = async () => {
  const response = await axios
    .get("/api/v1/users", {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return dataFormatter.deserialize(response.data).map((obj) => {
      return convertToCamelCase(obj);
    });
  }
};

export const loadUser = async (id) => {
  const response = await axios
    .get(`/api/v1/users/${id}`, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((errors) => {
      throw errors;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const destroyUser = async (id) => {
  const response = await axios
    .delete(`/api/v1/users/${id}`, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const blockUser = async (blocked, id) => {
  const response = await axios
    .post(
      `/api/v1/users/${id}/block`,
      { data: { attributes: { blocked: blocked } } },
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};
